module.exports = __webpack_public_path__ + "static/media/ChevronDown.6a061168.svg";